export default __webpack_public_path__ + "static/media/toyota-corolla-l8.d80520c9.png";